import swal from 'sweetalert2';

export function createAjaxErrorHandler({message = 'An error has occurred.', modal = true, silent = false} = {}) {
  return function (xhr, status, error) {
    // If the xhr request was cancelled, don't show an error message
    if (typeof xhr.getAllResponseHeaders === 'function' && !xhr.getAllResponseHeaders()) {
        return;
    }
    // Return a 4xx error code with JSON {'errors': [...]} to show a friendlier message
    if (xhr.status >= 400 && xhr.status < 500) {
      try {
        const data = JSON.parse(xhr.responseText);
        if (data.errors) {
          if (data.fields) {

          }
          swal({
            type: 'error',
            title: 'Problem Detected',
            text: data.errors[0],
          });
          return;
        }
      } catch (e) {
      }
    }

    console.error(`Failed to execute XMLHTTPRequest; status=${status}; error=${error})`);

    if (!silent) {
      swal({
        type: 'error',
        title: 'Problem Detected',
        text: 'Something went wrong. Try refreshing the page if the problem persists.',
      });
    }

    return new Promise((resolve, reject) => reject(error));
  }
}